// ** React Imports
import { Fragment, useEffect, memo, useState } from "react"

// ** Third Party Components
import classnames from "classnames"
// import { useParams } from 'react-router-dom'
// ** Store & Actions
import { useSelector, useDispatch } from "react-redux"
import {
  handleContentWidth,
  handleMenuCollapsed,
  handleMenuHidden
} from "../../../../redux/layout"

// ** ThemeConfig
import themeConfig from "../../../../configs/themeConfig"
import { useLocation } from 'react-router-dom'

import LoadingOpaqueSpinner from "../../../../components/spinner/Loading-opaque-spinner"

// ** Styles
// import { AnimatePresence } from "framer-motion/dist/framer-motion"
import "animate.css/animate.css"
import GlobalVariable from "../../../../settings/global"
const headerText = GlobalVariable.headerText

const LayoutWrapper = (props) => {
  // ** Props
  const { children, routeMeta } = props

  // ** Store Vars
  const dispatch = useDispatch()
  // const { catCode } = useParams()
  const store = useSelector((state) => state)

  const stores = useSelector((state) => state.commonreducerSlice)
  const uiSlice = useSelector((state) => state.uiSlice)


  const navbarStore = store.navbar
  const layoutStored = store.layout.layout
  const contentWidth = store.layout.contentWidth
  const [windowWidth, setWindowWidth] = useState(window.innerWidth)
  const [loadingOpaqueSpinner, setLoadingOpaqueSpinner] = useState(false)
  const handleWindowWidth = () => {
    setWindowWidth(window.innerWidth)
  }
  //** Vars
  const appLayoutCondition =
    (layoutStored.layout === "horizontal" && !routeMeta) ||
    (layoutStored.layout === "horizontal" && routeMeta && !routeMeta.appLayout)
  const Tag = appLayoutCondition ? "div" : Fragment

  const location = useLocation()
  function zIndexStyle() {
    const pathParts = location.pathname.split("/")

    if ((pathParts.includes("home")) || (pathParts.includes("FA") && pathParts.includes("dashboard"))) {
      return { overflow: "unset" }
    }

    return { overflow: "hidden" }
  }

  // ** Clean Up Function
  const cleanUp = () => {
    if (routeMeta) {
      if (
        routeMeta.contentWidth &&
        routeMeta.contentWidth === store.layout.contentWidth
      ) {
        dispatch(handleContentWidth(themeConfig.layout.contentWidth))
      }
      if (
        routeMeta.menuCollapsed &&
        routeMeta.menuCollapsed === store.layout.menuCollapsed
      ) {
        dispatch(handleMenuCollapsed(!store.layout.menuCollapsed))
      }
      if (
        routeMeta.menuHidden &&
        routeMeta.menuHidden === store.layout.menuHidden
      ) {
        dispatch(handleMenuHidden(!store.layout.menuHidden))
      }
    }
  }

  useEffect(() => {
    if (window !== undefined) {
      window.addEventListener("resize", handleWindowWidth)
    }
  }, [windowWidth])

  useEffect(() => {
    setLoadingOpaqueSpinner(uiSlice?.isProcessing)
  }, [uiSlice?.isProcessing])

  // ** ComponentDidMount
  useEffect(() => {
    if (routeMeta) {
      if (routeMeta.contentWidth) {
        dispatch(handleContentWidth(routeMeta.contentWidth))
      }
      if (routeMeta.menuCollapsed) {
        dispatch(handleMenuCollapsed(routeMeta.menuCollapsed))
      }
      if (routeMeta.menuHidden) {
        dispatch(handleMenuHidden(routeMeta.menuHidden))
      }
    }
    return () => cleanUp()
  }, [routeMeta])

  return (
    <>
      {loadingOpaqueSpinner && <LoadingOpaqueSpinner />}
      <div
        className={classnames("app-content content", {
          [routeMeta ? routeMeta.className : ""]:
            routeMeta && routeMeta.className,
          "show-overlay": navbarStore.query.length
        }
        )}
        style={zIndexStyle()}

      >

        <div className="content-overlay"></div>
        <div className="header-navbar-shadow" />
        <div
          className={classnames({
            "content-wrapper": routeMeta && !routeMeta.appLayout,
            "content-area-wrapper": routeMeta && routeMeta.appLayout,
            "pb-1": contentWidth === "boxed",
            collapse_menu: !store.layout.menuCollapsed
          })}
          // style={{ height: '100%', marginRight: '-48px', marginTop: catCode ? '-11px' : -11, marginLeft: catCode ? (store.layout.menuCollapsed === false ? '150px' : (store.layout.menuCollapsed === true ? '25px' : 0)) : (store.layout.menuCollapsed === false ? '150px' : (store.layout.menuCollapsed === true ? '25px' : 0)) }}

          // style={{ height: '100%', marginRight: '13px', marginTop: headerText ? 'opx' : '2px', marginLeft: store.layout.menuCollapsed ? '65px' : '237px' }}

          style={{ height: '100%', marginRight: '-17px', marginTop: headerText ? 'opx' : '2px', marginLeft: windowWidth <= 1200 ? "-17px" : store.layout.menuCollapsed ? '237px' : '237px' }}

        >
          <Tag {...(appLayoutCondition ? { className: "content-body" } : {})}>
            {children}
          </Tag>
        </div>
      </div>
    </>
  )
}

export default memo(LayoutWrapper)
